import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LottieFilesService {
  private readonly http = inject(HttpClient);

  currLottieFiles = {};

  setLottieFile(name, obj) {
    this.currLottieFiles[name] = obj;
  }

  getLottieFile(name) {
    return this.currLottieFiles[name];
  }

  getLottieJson(name): Observable<unknown> {
    return this.http.get(`assets/svgs/icon-data/${name}.json`);
  }
}
